import { useRecoilValue } from 'recoil';
import { Api } from 'shared/services/api';
import { calculateRemainingTime } from 'shared/utils';

import { sessionUser, erroLogin } from './atoms';

export const useSessionUser = () => {
  
  const token = Api.defaults.headers.common['Authorization'];
  const user = useRecoilValue(sessionUser);
  if(!token && user){
    Api.defaults.headers.common['Authorization'] = `Bearer ${user.token}`;
  }
  
  if(user){
    const remainingTime = calculateRemainingTime(user.exp * 1000);
    if(remainingTime < 6000){
      return null;
    }
  }
    
  return user;
};

export const useErroLogin = () => useRecoilValue(erroLogin);
